/* eslint-disable no-restricted-globals */
if (typeof self !== 'undefined') {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN =
    process.env.GATSBY_APPCHECK_DEBUG_TOKEN ||
    (process.env.NODE_ENV === 'development' ? (process.env.GATSBY_BUILD_KEY || true) : undefined);
}
